var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadericon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.896,
    height: 66.939,
    viewBox: "0 0 62.896 66.939",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1101.664 -648.262) rotate(120)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1149.858,561a8,8,0,1,1-8-8,8,8,0,0,1,8,8",
    transform: "translate(-14.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1176.144,577.713a6.858,6.858,0,1,1-6.858-6.858,6.857,6.857,0,0,1,6.858,6.858",
    transform: "translate(-24.429 -6.428)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1181,608.713a5.714,5.714,0,1,1-5.715-5.713,5.714,5.714,0,0,1,5.715,5.713",
    transform: "translate(-27.001 -18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1164.43,636.143a4.572,4.572,0,1,1-4.573-4.572,4.571,4.571,0,0,1,4.573,4.572",
    transform: "translate(-21.857 -28.286)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1132.286,643.285a4.572,4.572,0,1,1-4.573-4.57,4.573,4.573,0,0,1,4.573,4.57",
    transform: "translate(-10.286 -30.857)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1105,624.286c0,4.57-6.858,4.57-6.858,0s6.858-4.572,6.858,0",
    transform: "translate(-1.285 -24.429)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1099.14,594.569a2.285,2.285,0,1,1-4.57,0,2.285,2.285,0,1,1,4.57,0",
    transform: "translate(0 -14.142)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1117,569.569a2.286,2.286,0,0,1-4.573,0,2.286,2.286,0,0,1,4.573,0",
    transform: "translate(-6.428 -5.142)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadericon);
export default __webpack_public_path__ + "static/media/loader.icon.3741a560756a6e7a945df7f52ea0d423.svg";
export { ForwardRef as ReactComponent };